// app-user · Offers tab + Saved tab strings that the design handoff chrome set
// (app-strings.ts, `app.offers.*` / `app.saved.*`) does not carry: parameterised
// "updated … ago", the filter-menu options, load-more, share, guest gate, offline / stale
// notices, a11y names. Spread into en.ts / bn.ts.
export const appEnOffers = {
  'app.offers.allAreas': 'All areas',
  'app.offers.areaA11y': 'Change area',
  'app.offers.updatedAgo': 'Updated {ago}',
  'app.offers.offlineAgo': 'You’re offline. Showing offers saved {ago}.',
  'app.offers.staleAgo': 'Couldn’t refresh. Showing offers saved {ago}.',
  'app.offers.savedAgoMinutes': '{n, plural, one{# minute ago} other{# minutes ago}}',
  'app.offers.savedAgoHours': '{n, plural, one{# hour ago} other{# hours ago}}',
  'app.offers.offlineNoCache': 'You’re offline. Connect to see the latest offers.',
  'app.offers.showMore': 'Show more offers',
  'app.offers.close': 'Close',
  'app.offers.sortDiscount': 'Highest % off',
  'app.offers.sortPrice': 'Lowest price',
  'app.offers.endsTodayOpt': 'Today',
  'app.offers.endsWeekOpt': 'This week',
  'app.offers.endsMonthOpt': 'This month',
  'app.offers.errMore': 'Couldn’t load more offers. Try again.',
  'app.offers.filtersEmptyT': 'No offers match these filters',
  'app.offers.filtersEmptyB': 'Clear a filter to see more deals.',
  'app.offers.clearFilters': 'Clear filters',
  'app.offers.saveOffer': 'Save offer',
  'app.offers.unsaveOffer': 'Remove saved offer',
  'app.offers.shareA11y': 'Share offer',
  'app.offers.shareMessage': '{title} — {url}',
  'app.offers.offLabel': '{n}% off',
  'app.offers.daysLeftN': '{n} days left',
  'app.saved.errT': 'Couldn’t load your saved list',
  'app.saved.errB': 'Something went wrong on our side. Try again in a moment.',
  'app.saved.staleNote': 'Couldn’t refresh. Showing the list saved on this phone.',
  'app.saved.unsaveA11y': 'Remove {name} from saved',
  'app.saved.offlineAction': 'You’re offline. Reconnect to change your saved list.',
  'app.saved.actionFailed': 'Couldn’t update your saved list. Try again.',
  'app.saved.dealAlertsA11y': 'Deal alerts',
  'app.saved.dealAlertsFailed': 'Couldn’t change deal alerts. Try again.',
  'app.saved.guestT': 'Sign in to see what you saved',
  'app.saved.guestB': 'Your favourites and saved offers live on your account.',
  'app.saved.guestCta': 'Sign in',
  'app.saved.ratingCount': '{rating} ({count})',
} as const satisfies Record<string, string>;

export const appBnOffers = {
  'app.offers.allAreas': 'সব এলাকা',
  'app.offers.areaA11y': 'এলাকা বদলান',
  'app.offers.updatedAgo': '{ago} আপডেট',
  'app.offers.offlineAgo': 'আপনি অফলাইনে। {ago} সেভ করা অফার দেখানো হচ্ছে।',
  'app.offers.staleAgo': 'রিফ্রেশ হয়নি। {ago} সেভ করা অফার দেখানো হচ্ছে।',
  'app.offers.savedAgoMinutes': '{n} মিনিট আগের',
  'app.offers.savedAgoHours': '{n} ঘণ্টা আগের',
  'app.offers.offlineNoCache': 'আপনি অফলাইনে। সর্বশেষ অফার দেখতে ইন্টারনেটে যুক্ত হোন।',
  'app.offers.showMore': 'আরও অফার দেখুন',
  'app.offers.close': 'বন্ধ করুন',
  'app.offers.sortDiscount': 'সর্বোচ্চ ছাড় %',
  'app.offers.sortPrice': 'সবচেয়ে কম দাম',
  'app.offers.endsTodayOpt': 'আজ',
  'app.offers.endsWeekOpt': 'এই সপ্তাহে',
  'app.offers.endsMonthOpt': 'এই মাসে',
  'app.offers.errMore': 'আরও অফার লোড হয়নি। আবার চেষ্টা করুন।',
  'app.offers.filtersEmptyT': 'এই ফিল্টারে কোনো অফার নেই',
  'app.offers.filtersEmptyB': 'আরও অফার দেখতে একটি ফিল্টার সরিয়ে দিন।',
  'app.offers.clearFilters': 'ফিল্টার মুছুন',
  'app.offers.saveOffer': 'অফার সেভ করুন',
  'app.offers.unsaveOffer': 'সেভ করা অফার সরান',
  'app.offers.shareA11y': 'অফার শেয়ার করুন',
  'app.offers.shareMessage': '{title} — {url}',
  'app.offers.offLabel': '{n}% ছাড়',
  'app.offers.daysLeftN': '{n} দিন বাকি',
  'app.saved.errT': 'আপনার সেভ তালিকা লোড হয়নি',
  'app.saved.errB': 'আমাদের দিকে একটা সমস্যা হয়েছে। একটু পরে আবার চেষ্টা করুন।',
  'app.saved.staleNote': 'রিফ্রেশ হয়নি। এই ফোনে সেভ করা তালিকা দেখানো হচ্ছে।',
  'app.saved.unsaveA11y': '{name} সেভ তালিকা থেকে সরান',
  'app.saved.offlineAction': 'আপনি অফলাইনে। সেভ তালিকা বদলাতে ইন্টারনেটে যুক্ত হোন।',
  'app.saved.actionFailed': 'সেভ তালিকা বদলানো যায়নি। আবার চেষ্টা করুন।',
  'app.saved.dealAlertsA11y': 'অফার অ্যালার্ট',
  'app.saved.dealAlertsFailed': 'অফার অ্যালার্ট বদলানো যায়নি। আবার চেষ্টা করুন।',
  'app.saved.guestT': 'কী সেভ করেছেন দেখতে সাইন ইন করুন',
  'app.saved.guestB': 'আপনার পছন্দ ও সেভ করা অফার অ্যাকাউন্টে থাকে।',
  'app.saved.guestCta': 'সাইন ইন',
  'app.saved.ratingCount': '{rating} ({count})',
} as const satisfies Record<string, string>;
